import { render, staticRenderFns } from "./RangeOfMotionObject.vue?vue&type=template&id=3251f3ce&scoped=true&"
import script from "./RangeOfMotionObject.vue?vue&type=script&lang=ts&"
export * from "./RangeOfMotionObject.vue?vue&type=script&lang=ts&"
import style0 from "./RangeOfMotionObject.vue?vue&type=style&index=0&id=3251f3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251f3ce",
  null
  
)

export default component.exports